
import React from 'react';
import { MapPin, Camera } from 'lucide-react';

interface UnsplashLocation {
  title?: string;
  name?: string;
  city?: string;
  country?: string;
}

interface UnsplashAttributionProps {
  photographerName: string;
  photographerUrl: string;
  location?: UnsplashLocation;
}

const UnsplashAttribution: React.FC<UnsplashAttributionProps> = ({
  photographerName,
  photographerUrl,
  location
}) => {
  
  console.log('🏷️ UnsplashAttribution received location data:', location);
  
  // Determine the best location string to display based on available data
  const getLocationString = () => {
    if (!location) {
      console.log('🏷️ No location data provided to attribution');
      return null;
    }
    // Check in priority order: title, name, city, country
    const locationString = location.title || location.name || location.city || location.country;
    console.log('🏷️ Location string determined:', locationString);
    return locationString;
  };
  
  const locationString = getLocationString();
  
  
  const textStyle = {
    color: 'rgba(255, 255, 255, 0.8)',
    fontSize: '12px',
    textShadow: '0px 1px 3px rgba(0, 0, 0, 0.5)',
    zIndex: 10
  };

  return (
    <div className="absolute bottom-3 left-3 flex flex-col gap-1">
      {/* Location information - only shown if available */}
      {locationString && (
        <div 
          className="text-xs flex items-center gap-1"
          style={textStyle}
        >
          <MapPin size={12} />
          Photo location {locationString}
        </div>
      )}
      
      {/* Photo attribution */}
      <div
        className="text-xs flex items-center gap-1"
        style={textStyle}
      >
        <Camera size={12} />
        Photo by{' '}
        <a
          href={photographerUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-white transition-colors"
        >
          {photographerName}
        </a>
        {' '}on{' '}
        <a
          href="https://unsplash.com"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-white transition-colors"
        >
          Unsplash
        </a>
      </div>
    </div>
  );
};

export default UnsplashAttribution;
